const apiBase = process.env.VUE_APP_API_BASE || 'http://localhost:3001'

/**
 * Resolve a URL that may be a relative /uploads/ path or an inline data: URL.
 * - /uploads/... → prepends API base URL
 * - data:...      → returned as-is (inline base64)
 * - http(s):...   → returned as-is (absolute)
 * - empty         → returns ''
 */
export function resolveUrl(url: string | null | undefined): string {
  if (!url) return ''
  if (url.startsWith('/uploads/')) return `${apiBase}${url}`
  return url
}
